import { TextField } from '@mui/material';
import { Component } from 'react';

export default class BarcodeInput extends Component {
    render() {
        return (
            <TextField
                {...this.props.props}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe um código" : null}
                size="small"
                variant="outlined"
                name="barcode"
                label={'Código de barra' + (this.props.required ? '*': '')}
                value={this.props.value?.replace(/[^0-9\u00C0-\u00FF ]/g, '')}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value) : {}} />
        );
    }
}